import React from "react";
import "./productCard.css";
import img from "../../Images/default.png";
import NoData from "../../COMPONENT/NoData";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCart } from "../../store/cartSlice";

function ProductCard() {
  const { data, url } = useSelector((state) => state.product);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSelectedProduct = (product) => {
    navigate(`/${url}/product/${product.productName}/${product._id}`);
  };

  const handleAdd = (item) => {
    let cart = JSON.parse(localStorage.getItem(url));

    if (!cart) {
      cart = [];
    }

    const existingItem = cart.find((cartItem) => cartItem._id === item._id);

    if (existingItem) {
      alert("This item is already in your cart.");
    } else {
      cart.push(item);
      localStorage.setItem(url, JSON.stringify(cart));
      alert("Item added to your cart.");
      dispatch(setCart(JSON.parse(localStorage.getItem(url))));
    }
  };

  return (
    <>
      {data.products ? (
        <div className="category-container1">
          {data.products.map((product, index) => (
            <div
              className="product-card1"
              key={index}
            >
              <div onClick={() => handleSelectedProduct(product)}>
              <img
                className="product-image1"
                src={
                  product.images.length > 0
                    ? `${process.env.REACT_APP_PRODUCT_IMAGE_PATH}${product.images[0]}`
                    : img
                }
                alt="Product"
              />
              <div className="product-details1">
                <div className="product-title1">{product.productName}</div>
                <div className="product-price1">
                  <span className="selling-price1">
                    ₹{product.sellingPrice}
                  </span>
                  <span>
                    <span className="original-price1">₹{product.MRP}</span>
                    <span className="discount1">
                      {(
                        ((product.MRP - product.sellingPrice) / product.MRP) *
                        100
                      ).toFixed(2)}
                      % off
                    </span>
                  </span>
                </div>
                </div>
                </div>
                <div className="button_container">
                <button className="button1" onClick={() => handleAdd(product)}>
                  Add to cart
                </button>
                </div>
            </div>
          ))}
        </div>
      ) : (
        <NoData />
      )}
    </>
  );
}

export default ProductCard;
